import { render, staticRenderFns } from "./ParameterValue.vue?vue&type=template&id=31f3f6a8&"
import script from "./ParameterValue.vue?vue&type=script&lang=ts&"
export * from "./ParameterValue.vue?vue&type=script&lang=ts&"
import style0 from "./ParameterValue.vue?vue&type=style&index=0&id=31f3f6a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports